import BaseAPI from "../api";


const path: string = "permission-config";


export class PermissionApi extends BaseAPI {
    static getAll(): Promise<any> {
        return this.api.get(`${path}`)
    }
}